<template>
  <div class="popular-filters">
    <div class="popular-filters__header">
          <slot name="header"></slot>
    </div>
    <div class="popular-filters__body">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showAllInclusive() {
      this.showDestinationSelector({
        boardTypeCode: 'AI'
      });
    },
    showHotelsWithMin4Stars() {
      this.showDestinationSelector({
        minHotelCategory: 4
      });
    },
    showCloseOnBeach() {
      this.showDestinationSelector({
        keywords: JSON.stringify(['ben'])
      });
    },
    showInclusiveTransfer() {
      this.showDestinationSelector({
        keywords: JSON.stringify(['transfer-MT'])
      });
    },
    showChildFrendly() {
      this.showDestinationSelector({
        keywords: JSON.stringify(['chf'])
      });
    },
    showDirectFlight() {
      this.showDestinationSelector({
        directFlight: true
      });
    },
    showOnlyAdults() {
      this.showDestinationSelector({
        keywords: JSON.stringify(['ado'])
      })
    },
    showCentralLocation() {
      this.showDestinationSelector({
        keywords: JSON.stringify(['lcs'])
      })
    },
    showDestinationSelector(query = {}) {
      this.$router.push({
        query: Object.assign({}, query, {
          searchwidget: 1
        })
      });
    }
  }
};
</script>